export default __webpack_public_path__ + "static/media/cashier.a0f127cc.svg";